import React, { useEffect, ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { MockStoresWindow } from 'mockStores/types';
import { PaypalEnvs } from 'types';

declare let window: MockStoresWindow;

const PAYPAL_SCRIPT = process.env.PAYPAL_SDK_URLS[PaypalEnvs.Sandbox];

function appendScript(src, onload) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = src;
  if (onload) {
    script.onload = onload;
  }
  document.head.appendChild(script);
}

const useStyles = createUseStyles({
  paypalButton: {
    paddingTop: '8px',
  },
});

function GuestPayPalButton(): ReactElement {
  const classes = useStyles();

  function renderPayPalButton(fundingSource, id) {
    window.paypal
      .Buttons({
        createOrder(data, actions) {
          console.log('MERCHANT CREATE ORDER', data, actions); // eslint-disable-line no-console
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: '0.01',
              },
            }],
          });
        },
        fundingSource,
        async onApprove(data, actions) {
          console.log('MERCHANT APPROVE ORDER', data, actions); // eslint-disable-line no-console
        },
        onCancel() {
          console.log('MERCHANT CANCEL ORDER'); // eslint-disable-line no-console
        },
        onError(err) {
          console.log('MERCHANT ERROR ORDER', err); // eslint-disable-line no-console
        },
      })
      .render(id);
  }

  useEffect(() => {
    appendScript(PAYPAL_SCRIPT, () => renderPayPalButton(window.paypal.FUNDING.CARD, '#guest-button-container'));
  }, []);

  return (
    <div id="guest-button-container" className={ classes.paypalButton } />
  );
}

export default GuestPayPalButton;
